function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
/**
 * @file 本地数据存储
 * @author dafo<huanghouin@baijiahulian.com>
 * @module util/storage
 */
import isClient from './detectClient';
import { detectStorage } from './detectStorageAvailability';

/**
 * 存储到 localStorage 的键名
 *
 * @type {string}
 */
var KEY = 'HABO_UNSENTD';

/**
 * storage 代理，某些手机浏览器禁用localStorage，需要做降级处理
 */
var storage = function (useLocalStorage) {
  if (detectStorage()) {
    return localStorage;
  }
  var data = Object.create(null);
  return {
    setItem: function setItem(key, value) {
      data[key] = String(value);
    },
    getItem: function getItem(key) {
      return data[key];
    },
    removeItem: function removeItem(key) {
      delete data[key];
    }
  };
}(isClient);

/**
 * 读取已存储的未发送 URL
 *
 * @return {string[]} 返回未发送的请求 URL 数组
 */
var read = function read() {
  return (isClient && storage.getItem(KEY) || '').split(',').filter(Boolean).reduce(function (map, url) {
    var _url$split = url.split('|'),
      _url$split2 = _slicedToArray(_url$split, 2),
      key = _url$split2[0],
      data = _url$split2[1];
    map[key] = data ? JSON.parse(decodeURIComponent(data)) : '';
    return map;
  }, {});
};

/**
 * 读取到的未发送 URL 数组
 *
 * @type {Object.<string, string | string[]>}
 */
var URLS = read();
var PENDINGS = {};

/**
 * 存储未发送的 URL
 *
 * @param {?string} url 待存储的 URL
 * @param {?Array=} data 待存储的 post 数据
 */
var save = function save(url, data) {
  if (url && (!PENDINGS[url] || data && URLS[url] !== data)) {
    var value = URLS[url] || '';
    if (data && data.length) {
      data = Array.isArray(data) ? data : [data];
      value = Array.isArray(value) ? value.concat(data) : data;
    }
    URLS[url] = value;
  }
  try {
    var savedData = Object.keys(URLS).reduce(function (list, key) {
      list.push(URLS[key] ? "".concat(key, "|").concat(encodeURIComponent(JSON.stringify(URLS[key]))) : key);
      return list;
    }, []);
    isClient && storage.setItem(KEY, savedData.join(','));
  } catch (e) {
    // eslint-disable-next-line no-console
    console.error(e.message);
  }
};
var pending = function pending(url) {
  return PENDINGS[url] = true;
};
var deletePending = function deletePending(url) {
  return PENDINGS[url] = false;
};

/**
 * 移除已发送的 URL
 *
 * @param {string} url 要移除的 URL
 * @param {boolean} 移除成功与否
 */
var remove = function remove(url) {
  if (!(url in URLS) && !PENDINGS[url]) {
    return false;
  }
  delete PENDINGS[url];
  delete URLS[url];
  save();
  return true;
};

/**
 * 清除存储数据
 */
var clear = function clear() {
  var reset = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
  Object.keys(URLS).forEach(function (url) {
    return delete URLS[url];
  });
  if (reset) {
    Object.keys(PENDINGS).forEach(function (url) {
      return delete PENDINGS[url];
    });
  }
  isClient && storage.removeItem(KEY);
};

/**
 * 重复发送未完成的请求
 *
 * @param {Function} request 发送请求的方法
 */
var resend = function resend(request) {
  if (!Object.keys(URLS).length) {
    return;
  }
  var params = Object.keys(URLS).filter(function (url) {
    return !PENDINGS[url];
  }).map(function (url) {
    PENDINGS[url] = true;
    var args = [url];
    // 一般 data 是空字符串
    var data = URLS[url];
    if (data) {
      args.push('', null, data);
    }
    return args;
  });
  clear();
  params.forEach(function (args) {
    return request.apply(void 0, _toConsumableArray(args));
  });
};
export default {
  read: read,
  save: save,
  remove: remove,
  resend: resend,
  clear: clear,
  pending: pending,
  deletePending: deletePending
};